"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToastDismissButton = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _lodestarIcons = require("@smartsheet/lodestar-icons");
var _react = _interopRequireWildcard(require("react"));
var _ToastAction = require("./ToastAction");
/**
 * @deprecated please use @smartsheet/sds-toast-state-service instead. See
 * https://webappassets.dev.smar.cloud/storybook/design-systems-team/lodestar-core/mainline/sds-toast-ui/storybook/index.html
 */
const ToastDismissButton = /*#__PURE__*/(0, _react.forwardRef)((props, ref) => {
  return /*#__PURE__*/_react.default.createElement(_ToastAction.ToastAction, (0, _extends2.default)({
    tabIndex: 0,
    ref: ref
  }, props), /*#__PURE__*/_react.default.createElement(_lodestarIcons.CloseIcon, {
    size: "small"
  }));
});
exports.ToastDismissButton = ToastDismissButton;
ToastDismissButton.displayName = "ToastDismissButton";
//# sourceMappingURL=ToastDismissButton.js.map